import { Volume2 } from "lucide-react";

export function MissionCard({ thumbnail, name, found, total, onSpeak }) {
  return (
    <div className="wmleye-mission" data-testid="mission-card">
      {thumbnail ? (
        <img className="wmleye-mission__thumb" src={thumbnail} alt="" />
      ) : (
        <div className="wmleye-mission__thumb" />
      )}
      <div>
        <div className="wmleye-mission__text" data-testid="mission-target">
          Find the {name}!
        </div>
        <div className="wmleye-mission__progress" data-testid="mission-progress">
          {found} of {total}
        </div>
      </div>
      <button
        className="wmleye-mission__speaker"
        onClick={onSpeak}
        data-testid="mission-speaker"
        aria-label={`Repeat mission: find the ${name}`}
      >
        <Volume2 size={20} aria-hidden />
      </button>
    </div>
  );
}
